import { Typography } from "@mui/material";
import React from "react";
import styles from "./ServicesCard.module.css";
import right_arrow from "assets/images/right-arrow.svg";
import { Link } from "react-router-dom";

function ServicesCard({
  link,
  handleOnClickLink,
  icon,
  title,
  description,
  linkText,
}) {
  return (
    <div className={styles.card}>
      <div className={styles.card_icon}>
        <img src={icon} alt="" />
      </div>
    <div className={styles.card_text}>
    <Typography variant="h6">{title}</Typography>
      <Typography>
        {description}
      </Typography>
    </div>
    
      <Link to={link} onClick={handleOnClickLink}>
        {linkText} <img src={right_arrow} alt="" />{" "}
      </Link>
    </div>
  );
}

export default ServicesCard;
